
function up_button_chat(){
    let origin = 25;
    let x = 60;
    let cur_pos = cint($(window).scrollTop());
    let max_height = $(".body-inner").height() - $(window).height();
    
    let diff =  max_height-cur_pos;
    // let set_height=0;
    // set_height = cint(x - diff) + origin;
    if (diff < x){
        $(".chat-app").fadeOut("fast");
    }else{
        $(".chat-app").fadeIn("fast");
    }
}

setTimeout(()=>{
    up_button_chat();
}, 1000)

frappe.ready(function() {
    frappe._messages = frappe.__messages || [];
    $(".language-picker__item").click(function(e){
        let lang = $(this).attr("lang");
        frappe.call({
            method:"fisierp.templates.base_fisierp.set_language",
            args:{
                lang:lang, 
                request_url:window.location.href
            },
            callback:(r)=>{
                console.log(r);
                if ( r.message.redirect){
                    window.location.href = r.message.redirect;
                }else{
                    window.location.reload();
                }
            }
        })
    });

    // oneline_text(".ts-pricing-header",".pricingsubtitle");

    frappe.provide("frappe.chat");
    frappe.chat.setup = ()=>{
        console.log("chat already initialize");
    }


    $(document).scroll(()=>{
        up_button_chat();
    })

    const element = $('.social-share');

    var blog_title =  $(".post-body .entry-title > a").text().trim();
    var description = $(".post-body .entry-content p").text().slice(0,120);

    if (typeof ensemble !== 'undefined') {
        // the variable is defined
        new ensemble.SocialShare(element,{
    
            // namespace
            ns: 'share',
            fx: true,
        
            // root element
            root: 'body',
        
            // default classname
            className: 'social-share',
        
            // link to share
            // defaults to location.href
            link: window.location.href,
        
            // page title to share
            // defaults to window.title
            title: blog_title,
        
            // description to share
            description: description,
        
            // actions to display
            displays: null,
        
            // action intents
            intents: {
              'facebook': 0,
              'twitter': 0,
              'whatsapp': 1,
              'messenger': 1,
              'telegram': 1,
              'linkedin': -1,
              'send-email': 2,
              'copy-link': 3,
              'web-share': 4
            },
        
            // URI strings
            uriform: {
              'facebook': 'https://facebook.com/sharer.php?u=%url%',
              'twitter': 'https://twitter.com/share?url=%url%&text=%title%',
              'whatsapp': 'https://api.whatsapp.com/send?text=%text%%url%',
              'messenger': 'fb-messenger://share/?link=%url%&app_id=%app_id%',
              'telegram': 'https://telegram.me/share/url?url=%url%&text=%text%',
              'linkedin': 'https://www.linkedin.com/sharing/share-offsite?mini=true&url=%url%&title=%title%&ro=false&summary=%summary%',
              'send-email': 'mailto:?subject=%subject%&body=%text%'
            },
        
            // selector to find link
            selectorLink: {
              element: 'link[rel="canonical"]',
              attribute: 'href'
            },
        
            // selector to find title
            selectorTitle: null,
        
            // selector to find description
            selectorDescription: {
              element: 'meta[name="description"]',
              attribute: 'content'
            },
        
            // Custom parameters for label
            label: {},
        
            locale: {
              label: 'Share',
              share: 'Share on %s',
              send: 'Send to %s',
              subject: "Fisi ERP - Article",
              text: "Fisi ERP, " +  blog_title + " ",
              email: 'Send via email',
              copy: 'Copy link',
              copied: 'Copied link!',
              'whatsapp': 'WhatsApp',
              'linkedin': 'LinkedIn',
              'web-share': 'Share'
            },
    
            onInit: function() {},
            onIntent: function() {}
        });
    }
    
})